<script setup>
const openxclusive = () => {
  window.open("https://1xclusive.bigcartel.com", "_blank")
}

openxclusive()
</script>